import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, delay, finalize, Observable, of, tap } from 'rxjs';
import { LoadingService } from 'src/app/share/loading/loading/loading.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { KEY_TOKEN } from '../../services/local-storage/local-storage.constant';
import { customSwal } from 'src/app/share/styles/sweetalert';

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {
  constructor(
    private loadingService: LoadingService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    setTimeout(() => {
      this.loadingService.show();
    }, 0);

    const data = this.localStorageService.getItem({ key: KEY_TOKEN });

    if (data?.token) {
      request = request.clone({
        setHeaders: {
          Authorization: data.token,
        },
      });
    }

    return next.handle(request).pipe(
      delay(200),
      tap((event) => {
        if (event instanceof HttpResponse) {
        }
      }),
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status !== 401) {
            customSwal.fire(
              'Erro',
              error.error?.message ||
                'Ops! Ocorreu um erro inesperado, tente novamente mais tarde.',
              'error'
            );
          }
          if (error.status === 401) {
            customSwal.fire(
              'Atenção',
              'Sua sessão expirou, faça login novamente.',
              'warning'
            );
          }
        }
        return of(error);
      }),
      finalize(() => {
        setTimeout(() => {
          this.loadingService.hide();
        }, 0);
      })
    );
  }
}
